module.exports = __webpack_public_path__ + "7e7ff50f8aff31ff7357a72a68f282da.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/astore.png
// module id = 743
// module chunks = 0